// extracted by mini-css-extract-plugin
module.exports = {"text":"page-link_text__1ChHf","element":"page-link_element__32WqJ"};